import { TERMINAL, acceptSnapshot } from '@/ai/protocol/contract'

// 方法绑定到原页面实例；不持有独立状态、请求实例或生命周期。
export default {
  terminal(turn) {
    return TERMINAL.includes(turn.state)
  },
  apply(incoming, authoritative = false) {
    if (!this.session || this.session.sessionId !== incoming.sessionId) return
    const scroll = this.$refs.scroll
    const current = this.turns.find(t => t.turnId === incoming.turnId)
    // Executions and candidate pagination update the existing reply in place.
    // Do not pull the reader to the bottom on submit or subsequent polling.
    const actionUpdate = current && (current.components || []).some(c => c.type === 'action_list')
    const follow = !actionUpdate && (!scroll || scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight < 120)
    // A manual full read may repair a same-revision local view; never replace a newer revision.
    const result = acceptSnapshot(authoritative && current && current.revision === incoming.revision ? null : current, incoming)
    const value = { ...result.snapshot, blocked: result.blocked }
    if (current) this.$set(this.turns, this.turns.indexOf(current), value)
    else this.turns.push(value)
    this.$nextTick(() => {
      if (follow && this.$refs.scroll)
        this.$refs.scroll.scrollTop = this.$refs.scroll.scrollHeight
    })
    this.armExpiry()
    this.schedule(value)
  },
  armExpiry() {
    clearTimeout(this._expiryTimer)
    this.now = Date.now()
    if (!this._alive || document.hidden) return
    const dates = this.turns.filter(t => !t.readOnly && t.state === 'WAITING_ACTION').flatMap(t => (t.components || []).map(c => c.interaction && Date.parse(c.interaction.expiresAt))).filter(n => n > this.now)
    if (dates.length) this._expiryTimer = setTimeout(() => this.armExpiry(), Math.min(2147483647, Math.min(...dates) - this.now + 10))
  },
  shouldPoll(turn) {
    return !!turn && !turn.readOnly && !this.terminal(turn) && turn.state !== 'WAITING_ACTION'
  },
  schedule(turn) {
    clearTimeout(this._poll)
    if (!this._alive || document.hidden || !this.shouldPoll(turn) || !this.latest || this.latest.turnId !== turn.turnId) return
    if (this._pollTurnId !== turn.turnId) { this._pollTurnId = turn.turnId; this._pollStartedAt = Date.now(); this._pollDelay = 1000 }
    const deadline = Date.parse(turn.deadlineAt) || (this._pollDeadline || (this._pollDeadline = Date.now() + 180000))
    if (Date.now() >= deadline) { this.errorCode = ''; this.error = this.pageState.copy.pollTimeout || '等待结果超时，请查询原任务进度，勿重复提交。'; return }
    const delay = Math.min(deadline - Date.now(), Math.max(1000, Math.min(5000, Math.max(turn.pollAfterMs || 1000, this._pollDelay || 1000))))
    this._poll = setTimeout(() => this.refresh(this.latest), delay)
  },
  async refresh(turn, manual = false) {
    if (!this._alive || !turn) return
    if (this._pollInFlight || this.busy) {
      if (manual) this.$toast('正在处理，请稍候再刷新', 1000)
      this.schedule(this.latest); return false
    }
    this._pollInFlight = true
    const epoch = this._pollEpoch || 0
    const sessionId = turn.sessionId
    const previousError = this.error
    try {
      // Explicit recovery reads the full snapshot; routine polling stays lightweight.
      const result = await this.call('turn/get', { sessionId, turnId: turn.turnId, ...(manual ? {} : { knownRevision: turn.revision }) })
      if (!this._alive || epoch !== (this._pollEpoch || 0) || !this.session || this.session.sessionId !== sessionId) return
      if (result.sessionId !== sessionId || result.turnId !== turn.turnId) throw new Error('WRONG_RESPONSE')
      this._pollFailures = 0
      // Do not erase a newer error raised by another operation while this read was pending.
      if (this.error === previousError && (manual || this._pollError === previousError)) { this.error = ''; this.errorCode = '' }
      this._pollError = null
      // Short foreground tasks poll every second after each response; never overlap requests.
      if (this._pollTurnId !== turn.turnId) { this._pollTurnId = turn.turnId; this._pollStartedAt = Date.now() }
      this._pollDelay = result.notModified && Date.now() - this._pollStartedAt >= 30000 ? 3000 : 1000
      if (!result.notModified) this.apply(result, manual)
      this.schedule(this.latest)
      if (manual) this.$toast(this.shouldPoll(result) ? '结果已刷新，请求仍在处理中' : '结果已刷新', 1000)
      return true
    } catch (error) {
      if (!this._alive || epoch !== (this._pollEpoch || 0) || !this.session || this.session.sessionId !== sessionId) return
      this.fail(error)
      if (manual && !error.silent) this.$toast('刷新失败，请重试或新建对话', 1500)
      this._pollError = this.error
      this._pollFailures = (this._pollFailures || 0) + 1
      if (!error.definitive && this._pollFailures < 3) { this._pollDelay = 5000; this.schedule(this.latest) }
      return false
    } finally { this._pollInFlight = false }
  }
}
